export default "__VITE_ASSET__49b39d74__"